(function () {
  'use strict';

  // Birthday tickets carry a form (age, gender, arrival time, wish) filled in on the
  // product page by the fiziland-tickets calendar. This blocks checkout while any
  // birthday line is still missing it. Kept apart from cart-date-check.js, which
  // answers a different question (is the picked date still available) and has to ask
  // the app proxy to find out — this one only reads the cart.

  if (!document.getElementById('cart-birthday-check-styles')) {
    const style = document.createElement('style');
    style.id = 'cart-birthday-check-styles';
    style.textContent = `
      .cart-birthday-toast {
        position: fixed;
        bottom: 2rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 100001;
        width: min(92vw, 44rem);
        background: #fff;
        border: 1.5px solid #fbbf24;
        border-radius: .8rem;
        box-shadow: 0 4px 24px rgba(0,0,0,.14);
        padding: 1.4rem 1.6rem;
        animation: _cbc-up .22s ease;
        font-size: 1.4rem;
        line-height: 1.5;
      }
      @keyframes _cbc-up {
        from { opacity: 0; transform: translateX(-50%) translateY(1.2rem); }
        to   { opacity: 1; transform: translateX(-50%) translateY(0); }
      }
      .cart-birthday-toast__header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
        margin-bottom: 1rem;
      }
      .cart-birthday-toast__title {
        font-weight: 700;
        font-size: 1.4rem;
        color: #92400e;
        margin: 0;
        line-height: 1.3;
      }
      .cart-birthday-toast__close {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 1.8rem;
        line-height: 1;
        color: #92400e;
        padding: 0;
        flex-shrink: 0;
        opacity: .65;
        transition: opacity .15s;
      }
      .cart-birthday-toast__close:hover { opacity: 1; }
      .cart-birthday-toast__list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: .6rem;
      }
      .cart-birthday-toast__list li {
        padding: .7rem .9rem;
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-radius: .5rem;
        color: #333;
        line-height: 1.4;
      }
      .cart-birthday-toast__list small {
        display: block;
        margin-top: .2rem;
        color: #92400e;
        font-size: 1.2rem;
      }
      @media (max-width: 749px) {
        .cart-birthday-toast {
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          transform: none;
          border-radius: 1.2rem 1.2rem 0 0;
          animation: _cbc-up-m .22s ease;
        }
        @keyframes _cbc-up-m {
          from { opacity: 0; transform: translateY(1.2rem); }
          to   { opacity: 1; transform: translateY(0); }
        }
      }
    `;
    document.head.appendChild(style);
  }

  const TOAST_ID = 'cart-birthday-check-toast';

  // #packeta_checkout is rendered by another app; cart-date-check.js skips it too.
  const BTN_SELECTOR = '.delivery-button, .cart__checkout-button:not(#packeta_checkout)';

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function removeToast() {
    document.getElementById(TOAST_ID)?.remove();
  }

  function showToast(btn, titles) {
    removeToast();

    const titleText = btn.dataset.msgErrorTitle || 'Unable to proceed with order';
    const closeLabel = btn.dataset.msgClose || 'Close';
    const reason = btn.dataset.msgBirthdayMissing || 'Birthday details are missing';

    const toast = document.createElement('div');
    toast.id = TOAST_ID;
    toast.className = 'cart-birthday-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');

    const header = document.createElement('div');
    header.className = 'cart-birthday-toast__header';

    const titleEl = document.createElement('p');
    titleEl.className = 'cart-birthday-toast__title';
    titleEl.textContent = titleText;
    header.appendChild(titleEl);

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'cart-birthday-toast__close';
    closeBtn.setAttribute('aria-label', closeLabel);
    closeBtn.textContent = '✕';
    closeBtn.addEventListener('click', removeToast);
    header.appendChild(closeBtn);

    toast.appendChild(header);

    const list = document.createElement('ul');
    list.className = 'cart-birthday-toast__list';
    list.innerHTML = titles
      .map(title => `<li><strong>${escHtml(title)}</strong><br><small>${escHtml(reason)}</small></li>`)
      .join('');

    toast.appendChild(list);
    document.body.appendChild(toast);

    setTimeout(removeToast, 10000);
  }

  function missingTitles(btn) {
    const raw = btn.dataset.missingBirthdayDetails;
    if (!raw || raw === '[]') return [];
    try {
      return JSON.parse(raw);
    } catch (_) {
      return [];
    }
  }

  // Capture phase on the document, so this runs before the date check's own
  // listener on the button and can stop it from firing a pointless request.
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest?.(BTN_SELECTOR);
      if (!btn) return;

      const titles = missingTitles(btn);
      if (!titles.length) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      showToast(btn, titles);
    },
    true
  );

  // cart/add.js returns only the added line, so fall back to the items snapshot
  // that rides along in the cart-icon-bubble section.
  function itemsFromSections(sections) {
    const html = sections && sections['cart-icon-bubble'];
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const script = doc.querySelector('[data-cart-date-check-items]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (_) {
      return null;
    }
  }

  function applyCartUpdate(items) {
    const titles = [];
    items.forEach(function (item) {
      const props = item.properties || {};
      // The marker is written by the calendar for every birthday line, filled in
      // or not, so an untouched form is still detectable here.
      if (props._birthdayTicket && !props._birthdayDetails) titles.push(item.title);
    });

    document.querySelectorAll(BTN_SELECTOR).forEach(function (btn) {
      btn.dataset.missingBirthdayDetails = JSON.stringify(titles);
    });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    const cartData = event && event.cartData;
    if (!cartData) return;

    const items = cartData.items || itemsFromSections(cartData.sections);
    if (items) applyCartUpdate(items);
  });
})();
